export default "__VITE_ASSET__Cbnva6IC__"